
<template>
	<v-container fluid="fluid" class="text-xs-center">
		<price-table @showUnits="getUnitsByPriceCat" ref="priceTable"></price-table>
		<v-card style="width: 100%" color="transparent" elevation-0>
			<v-list>
				<v-list-tile
					avatar
					v-for="item in unitsInPriceCat"
					:key="item.unitId"
					@click="selectUnit(item)"
				>
					<v-list-tile-content>
						<v-list-tile-title
							>{{ item.name }} {{ item.license }}</v-list-tile-title
						>
					</v-list-tile-content>
				</v-list-tile>
			</v-list>
		</v-card>
		<unit-modal
			:id="unit.unitId"
			:edit="edit"
			:selectedUnit="unit"
			:new="newUnit"
			ref="unitModal"
			@updateUnits="updateUnits()"
		></unit-modal>
		<v-btn
			fixed
			dark
			fab
			bottom
			right
			color="pink"
			@click="$refs.newPriceModal.showModal = true"
		>
			<v-icon>add</v-icon>
		</v-btn>
		<new-price-group
			ref="newPriceModal"
			@update="priceCreated($event)"
		></new-price-group>
	</v-container>
</template>
<script>
import * as utils from '@/utils/utils';
import PriceTable from '@/components/Prices/PriceTable';
import UnitModal from '@/components/Units/UnitModal';
import NewPriceGroup from '@/components/Prices/NewPriceGroup.vue';

export default {
	name: 'Prices',
	components: { PriceTable, UnitModal, NewPriceGroup },
	data() {
		return {
			utils: utils,
			unitsInPriceCat: [],
			unit: {},
			newUnit: {},
			edit: {
				showModal: false
			}
		};
	},
	created() {},
	watch: {},
	methods: {
		getUnitsByPriceCat(data) {
			var self = this;
			self.unitsInPriceCat = [];
			utils
				.getData(basePath + 'api/rentunits/getUnitsByPriceCat/' + data.priceCat)
				.then(function(json) {
					if (json && json.data) {
						self.unitsInPriceCat = json.data;
					} else {
						self.unitsInPriceCat = [];
					}
				});
		},
		updateUnits() {},
		selectUnit(unit) {
			let editUnit = Object.assign({}, unit);
			this.$refs.unitModal.showModal = true;
			this.$refs.unitModal.unitData = editUnit;
			this.$refs.unitModal.selectedUnit = editUnit;
			this.$refs.unitModal.getUnit();
			this.$refs.unitModal.getUnitSensorData();
		},
		newPrice() {},
		priceCreated(data) {
			this.$refs.priceTable.selectedPrice = String(data.priceCat);
			this.$refs.priceTable.getData();
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/components/Prices/Prices.vue